import { Routes, Route } from 'react-router-dom';
import './App.css';
// import Navbar from './Components/Navbar/Navbar'
import Home from './Components/Home/Home';
import About from './Components/About/About';
import { BallTriangle } from 'react-loader-spinner';
import { useState } from 'react';
import { useEffect } from 'react';

function App() {
  const [loading, setLoading] = useState(false)
  useEffect(() => {
    setLoading(true)
    setTimeout(() => {
      setLoading(false)
    }, 1500)
  }, [])
  return (
    <div className="App">
      {loading ?
        (<div className='loading'>
          <BallTriangle
            height={100}
            width={100}
            radius={5}
            color="#D33B6A"
            ariaLabel="ball-triangle-loading"
            wrapperClass={{}}
            wrapperStyle=""
            visible={true}
          />
        </div>)
        : <>
          {/* <Navbar></Navbar> */}
          <Routes>
            <Route path='/' element={<Home></Home>}></Route>
            <Route path='/about' element={<About></About>}></Route>
          </Routes>
        </>
      }

    </div>
  );
}

export default App;
